(() => {
  "use strict";

  const SELECTOR = "[data-kenzu-contact]";

  const initialize = (root = document) => {
    const sections = [];

    if (root.matches?.(SELECTOR)) {
      sections.push(root);
    }

    root.querySelectorAll?.(SELECTOR).forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.contactInitialized === "true") return;

      section.dataset.contactInitialized = "true";

      const form = section.querySelector(".kenzu-contact__form");
      const submitButton = section.querySelector("[data-contact-submit]");
      const successMessage = section.querySelector("[data-contact-success]");

      form?.addEventListener("submit", () => {
        if (!form.checkValidity() || !submitButton) return;

        submitButton.classList.add("is-loading");
        submitButton.disabled = true;
        submitButton.setAttribute("aria-busy", "true");
      });

      if (successMessage) {
        requestAnimationFrame(() => {
          successMessage.focus({ preventScroll: true });
          successMessage.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
              ? "auto"
              : "smooth",
            block: "center"
          });
        });
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialize(document),
      { once: true }
    );
  } else {
    initialize(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });
})();